import React from 'react';
//import './SponsoredPage.css';
import Sponsore from './Sponsore/Sponsore';
import Nav from './inc/Nav/SponsoredNav';
import Footer from '../LandingPage/inc/Footer/Footer';
import ContactBanner from '../LandingPage/ContactBanner/ContactBanner';

const SponsoredPage: React.FC = () => {
    return (
        <div>
            <Nav />
            <Sponsore title = "GET SPONSORED"/>
            <ContactBanner />
            <Footer />
        </div>
    );
};

export default SponsoredPage;